
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem6Grid extends Serenity.EntityGrid<PsAdvPromoItem6Row, any> {
        protected getColumnsKey() { return PsAdvPromoItem6Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem6Dialog; }
        protected getIdProperty() { return PsAdvPromoItem6Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem6Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem6Row.localTextPrefix; }
        protected getService() { return PsAdvPromoItem6Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}